<template>
  <div class="product-list">
    <el-card shadow="hover" class="search-card">
      <el-form :inline="true" :model="searchForm" @submit.native.prevent="handleSearch">
        <el-form-item label="上架状态">
          <el-select v-model="searchForm.isUp" placeholder="全部" clearable style="width: 120px">
            <el-option label="上架中" :value="1"></el-option>
            <el-option label="已下架" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商品类型">
          <el-select v-model="searchForm.typeId" placeholder="全部" clearable style="width: 130px">
            <el-option label="社区商品" :value="1"></el-option>
            <el-option label="商户商品" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="关键词">
          <el-input
            v-model="searchForm.keyword"
            placeholder="商品名称"
            clearable
            style="width: 180px"
            @keyup.enter.native="handleSearch"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
          <el-button icon="el-icon-refresh" @click="resetSearch">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <el-card shadow="hover" class="table-card">
      <el-table :data="tableData" v-loading="loading" stripe border>
        <el-table-column prop="id" label="ID" width="70" align="center"></el-table-column>
        <el-table-column prop="name" label="商品名称" min-width="180"></el-table-column>
<!--        <el-table-column prop="category" label="分类" width="100"></el-table-column>-->
        <el-table-column label="类型" width="90" align="center">
          <template slot-scope="{ row }">
            <el-tag size="small" :type="row.typeId === 1 ? 'success' : 'warning'">
              {{ row.typeId === 1 ? '社区' : '商户' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="所属社区/商户" min-width="150">
          <template slot-scope="{ row }">
          <span v-if="row.typeId === 1">
            {{ getCommunityName(row.communityId) }}
          </span>
            <span v-else>
            {{ getMerchantName(row.merchantId) }}
          </span>
          </template>
        </el-table-column>
        <el-table-column label="总量/已领" width="120" align="center">
          <template slot-scope="{ row }">
            {{ row.total || 0 }} / {{ row.claimedCount || 0 }}
          </template>
        </el-table-column>

        <el-table-column label="上架状态" width="90" align="center">
          <template slot-scope="{ row }">
            <el-tag :type="row.isUp === 1 ? 'success' : 'info'" size="small">
              {{ row.isUp === 1 ? '上架中' : '已下架' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="expireTime" label="截止时间" width="170">
          <template slot-scope="{ row }">
            {{ formatTime(row.expireTime) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200" fixed="right">
          <template slot-scope="{ row }">
            <el-button size="mini" type="primary" @click="handleToggle(row)">
              {{ row.isUp === 1 ? '下架' : '上架' }}
            </el-button>
<!--            <el-button size="mini" type="danger" @click="handleForceDown(row)">强制下架</el-button>-->
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[10, 20, 50]"
        :page-size="size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        class="pagination"
      ></el-pagination>
    </el-card>

    <!-- 强制下架弹窗 -->
    <el-dialog title="强制下架" :visible.sync="forceVisible" width="400px">
      <el-form>
        <el-form-item label="下架原因" required>
          <el-input v-model="forceReason" type="textarea" :rows="3" placeholder="请输入强制下架原因"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="forceVisible = false">取 消</el-button>
        <el-button type="danger" :loading="submitting" @click="doForceDown">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getProductList, toggleProduct, forceDownProduct } from '@/api/product'
import {getMerchantNameList} from "@/api/merchant";
import {getCommunityList} from "@/api/community";


export default {
  name: 'ProductList',
  data() {
    return {
      searchForm: { isUp: '', typeId: '', keyword: '' },
      tableData: [],
      communities: [],
      merchants: [],
      loading: false,
      page: 1,
      size: 10,
      total: 0,
      forceVisible: false,
      forceReason: '',
      currentRow: null,
      submitting: false
    }
  },
  mounted() {
    this.loadCommunities();
    this.loadData()
  },
  methods: {
    async loadCommunities() {
      try {
        const res = await getMerchantNameList()
        const list = res.records || res.list || res.items || res || []
        this.merchants = Array.isArray(list) ? list : []

        const res2 = await getCommunityList('', 1, 100)
        const list2 = res2.records || res2.list || res2.items || res2 || []
        this.communities = Array.isArray(list2) ? list2 : []
      } catch (e) {}
    },
    async loadData() {
      this.loading = true
      try {
        const res = await getProductList(this.searchForm.typeId, this.searchForm.isUp, this.searchForm.keyword, this.page, this.size)
        const list = res.records || res.list || res.items || res || []
        this.tableData = Array.isArray(list) ? list : []
        this.total = res.total || this.tableData.length
      } catch (e) {
        this.tableData = []
        this.total = 0
      } finally {
        this.loading = false
      }
    },
    handleSearch() { this.page = 1; this.loadData() },
    resetSearch() { this.searchForm = { isUp: '', typeId: '', keyword: '' }; this.page = 1; this.loadData() },
    handleSizeChange(val) { this.size = val; this.loadData() },
    handleCurrentChange(val) { this.page = val; this.loadData() },
    getMerchantName(id) {
      const c = this.merchants.find(x => x.id === id)
      return c ? c.name : '-'
    },
    getCommunityName(id) {
      const c = this.communities.find(x => x.id === id)
      return c ? c.name : '-'
    },
    async handleToggle(row) {
      try {
        await toggleProduct(row.id)
        this.$message.success(row.isUp === 1 ? '已下架' : '已上架')
        this.loadData()
      } catch (e) {}
    },
    handleForceDown(row) { this.currentRow = row; this.forceReason = ''; this.forceVisible = true },
    async doForceDown() {
      if (!this.forceReason.trim()) return this.$message.warning('请输入下架原因')
      this.submitting = true
      try {
        await forceDownProduct(this.currentRow.id, this.forceReason)
        this.$message.success('强制下架成功')
        this.forceVisible = false
        this.loadData()
      } catch (e) {} finally {
        this.submitting = false
      }
    },
    formatTime(t) { return t ? new Date(t).toLocaleString('zh-CN', { hour12: false }) : '-' }
  }
}
</script>

<style scoped>
.product-list { padding: 0; }
.search-card { margin-bottom: 16px; border-radius: 8px; }
.table-card { border-radius: 8px; }
.pagination { margin-top: 16px; text-align: right; }
</style>
